import img0 from "./0.json";
import img1 from "./10.json";
import img2 from "./20.json";
import img3 from "./30.json";
import img4 from "./40.json";
import img5 from "./50.json";
import img6 from "./60.json";
import img7 from "./70.json";
import img8 from "./80.json";
import img9 from "./90.json";
import img10 from "./100.json";

export default [
  img0,
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
];
